import React, {useMemo} from 'react'

function useChildrenProps<T>(
  children: React.ReactNode,
  type?: (props: T) => any
): [T[], React.ReactNode[]] {
  return useMemo(() => {
    const items: T[] = []
    const others: React.ReactNode[] = []

    React.Children.toArray(children).forEach((child: any) => {
      const hasType = !type || child.type === type
      if (hasType) items.push(child.props)
      else others.push(child)
    })

    return [items, others]
  }, [children, type])
}

export default useChildrenProps
